module.exports = __webpack_public_path__ + "media/images/icons/series-b8720e8a60904fe92ae7cd1eb922f7f5.gif";